function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactPlayer from 'react-player';

// Class

var PreviewVideo = function (_Component) {
  _inherits(PreviewVideo, _Component);

  function PreviewVideo() {
    var _temp, _this, _ret;

    _classCallCheck(this, PreviewVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getResource = function (resource) {
      var mimeType = resource.mimeType,
          url = resource.url;


      return {
        type: mimeType,
        src: url
      };
    }, _this.getUrls = function () {
      var media = _this.props.formData.media;
      var resources = media.resources;


      var urls = [];

      if (resources['mp3']) {
        urls.push(_this.getResource(resources['mp3']));
      }

      if (resources['ogg']) {
        urls.push(_this.getResource(resources['ogg']));
      }

      return urls;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PreviewVideo.prototype.render = function render() {

    var urls = this.getUrls();

    return React.createElement(ReactPlayer, { className: 'audio', url: urls, controls: true });
  };

  return PreviewVideo;
}(Component);

export default PreviewVideo;